<template>
  <div
    class="r-ipt-text common-flex common-justify-between common-align-center"
    :style="[{ width: width + 'px' }]"
  >
    <div
      class="title"
      :style="{ width: titleWidth + 'px',fontSize:(config.name.length>14?10:14)+'px'}"
      @click="onTitleClick"
      ref="bnlj"
    >
      <span v-if="config.isMust" style="color: red">*</span>{{ config.name }}
    </div>
    <div class="common-flex common-align-center fills">
      <form v-if="config.maxValue && config.minValue" style="flex:1">
        <Poptip :transfer="true" trigger="focus" style="width: 100%">
          
          <input
            @wheel.prevent="handleWheel"
            @keydown.up.prevent 
            @keydown.down.prevent
            
            style="width:90%"
             type="number"
            :class="bg?'bg-grey':''"
            @input="input"
            @blur="blur"
            @focus="focus"
            :style="
              config.inputValue != '' &&
              (config.inputValue > config.maxValue ||
                config.inputValue < config.minValue)
                ? { color: '#CC170A' }
                : {}
            "
               :disabled='config.disabled'
            v-model="config.inputValue"
          />
          <div slot="content">
            {{ config.minValue + " ~ " + config.maxValue +" "+ unit.heightUnitName }}
          </div>
        </Poptip>
      </form>
      <form v-else style="flex:1">
        <Poptip
        :transfer="true"
          :disabled="!config.minValue ? true : false"
          trigger="focus"
          style="width: 100%"

        >
          <input
          @wheel.prevent="handleWheel"
          @keydown.up.prevent 
          @keydown.down.prevent
          
          style="width:90%"
            type="number"
            :class="bg?'bg-grey':''"
            @input="input"
            @blur="blur"
            @focus="focus"
            :style="
              config.inputValue != '' &&
              (config.inputValue > config.maxValue ||
                config.inputValue < config.minValue)
                ? { color: '#CC170A' }
                : {}
            "
            :disabled='config.disabled'
            v-model="config.inputValue"
          />
          <div slot="content">
            {{ config.minValue + "~" + config.maxValue + unit.heightUnitName }}
          </div>
        </Poptip>
      </form>
      <!-- 净体显示成衣数据 -->
      <span v-if="sizeTypeId==10052&&config.finishId">
        <form v-if="config.maxValue && config.minValue" style="flex:1">
          <Poptip disabled trigger="focus" style="width: 100%">
            <input
            @wheel.prevent="handleWheel"
            @keydown.up.prevent 
            @keydown.down.prevent
            
               type="number"
              :class="bg?'bg-grey':''"
              @input="input"
              @blur="blur"
              @focus="focus"
                 :disabled='config.disabled'
              v-model="config.finishValue"
            />
            <!-- <div slot="content">
              {{ config.minValue + "~" + config.maxValue + unit.heightUnitName }}
            </div> -->
          </Poptip>
        </form>
        <form v-else style="flex:1">
          <Poptip
          disabled
            trigger="focus"
            style="width: 100%"

          >
            <input
            @wheel.prevent="handleWheel"
            @keydown.up.prevent 
            @keydown.down.prevent
            
              type="number"
              :class="bg?'bg-grey':''"
              @input="input"
              @blur="blur"
              @focus="focus"
              :disabled='config.disabled'
              v-model="config.finishValue"
            />
            <!-- <div slot="content">
              {{ config.minValue + "~" + config.maxValue + unit.heightUnitName }}
            </div> -->
          </Poptip>
        </form>
      </span>

      <div class="icons common-hover" v-if="addMove">
        <div
          @click="add"
          style="
            height: 14px;
            text-align: center;
            line-height: 14px;
            width: 40px;
            border-bottom: 1px solid #dfe6f2;
          "
        >
          <Icon type="ios-arrow-up" />
        </div>

        <div
          @click="move"
          style="
            height: 14px;
            text-align: center;
            line-height: 14px;
            width: 40px;
          "
        >
          <Icon type="ios-arrow-down" />
        </div>
      </div>
      <div class="suffix">{{ unit.heightUnitName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "r-ipt-text",
  data() {
    return {
      blue:false
    };
  },
  /*label 标题
    isMust 是否必填,
    type 类型,
    inputvalue  输入数据
    suffixValue 后缀
    maxValue 最大值
    minValue 最小值
  */
  props: {
    sizeTypeId:[Number, String],
    config: Object,
    // parent: [Object,Array],
    // sindex: Number,
    width: {
      type: [Number, String],
      default: 350,
    },
    titleWidth: {
      type: [Number, String],
      default: 172,
    },
    addMove: {
      type: Boolean,
      default: false,
    },
    unit: [String, Object],
    bg: {
      type: Boolean,
      default:false
    }
  },

  methods: {
    handleWheel(event) {
      console.log(1)
      event.preventDefault();
    },
    focus(){
      this.blue = true
    },
    blur(){
      this.blue = false
    },
    add() {
      this.config.inputValue =
        Number(this.config.inputValue) + Number(this.config.addNum);
      // this.parent.splice(this.sindexthat.$forceUpdate(),1,this.config)
      this.$forceUpdate();
      // console.log('add',this.parent)
      // this.$set(this.config,'inputValue',Number(this.config.inputValue) + Number(this.config.addNum))
    },
    input() {
      this.$forceUpdate();
    },
    move() {
      this.config.inputValue =
        Number(this.config.inputValue) - Number(this.config.addNum);
      this.$forceUpdate();
      // this.parent.splice(this.sindex,1,this.config)
      // this.$set(this.config,'inputValue',Number(this.config.inputValue) - Number(this.config.addNum))
    },
    onTitleClick(e) {
      if (e.target.classList.contains("title")) {
        const nextEle = e.target.nextElementSibling;
        nextEle.querySelector("input").focus();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-poptip-popper {
  min-width: 50px;
}
.fills {
  flex-grow: 1;
  justify-content: space-between;
}
.r-ipt-text {
  // width: 350px;
  padding-bottom: 2px;
  border-bottom: 0.5px solid #666666;
  .icons {
    height: 29px;
    border-radius: 2px;
    border: 1px solid #dfe6f2;
    width: 40px;
    background: #f8f8f8;
    margin-right: 5px;
  }
  .title {
    // width: 300px;
    // width:172px;
  }
  input {
    width: 90px;
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
    // text-align: right;
    // padding-right: 5px;
    margin: 0 21px 0 0;
    text-align: center;
    background: #f8fafe;
    border-radius: 4px;
    font-weight: 500;
   line-height: 1;
  }
  input[type="text"]:focus {
    border: 1px solid #0A4DCC;
    color: #0A4DCC;
    text-align: center;
  }
  .suffix {
    width: 68px;
    height: 30px;
    color: #4f5b70;
    font-family: Roboto;
    font-size: 14px;
    line-height: 30px;
    background: #f8f8f8;
    border-radius: 4px;
    text-align: center;
    margin-bottom:3px;
  }

  /deep/ .ivu-poptip-rel {
    width: 100%;
  }
}
.bg-grey{
  width:90px!important;
  height: 30px;
  background: rgba(10,77,204,.03);
  border-radius: 4px;
  box-shadow: 0px 0px 7px 0px rgba(10,77,204,0.06) inset;
  text-align:center;
  font-weight: bold;
}
.title {
  /deep/ .ivu-poptip-rel{
    width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    appearance:none;
    -webkit-appearance: none !important;
    margin: 0;
}
input[type=number]{
  -moz-appearance:textfield;
}

</style>



// WEBPACK FOOTER //
// src/components/r-ipt-text-finish.vue